var _defs, _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.115,
    height: 24.1,
    viewBox: "0 0 24.115 24.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.058,
    cy: 12.05,
    rx: 12.058,
    ry: 12.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.572 12.051) rotate(135)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.637,
    height: 13.455,
    transform: "translate(5.408 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.455,
    height: 2.637,
    transform: "translate(0 5.407)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico-close.c81aeb791b4f00b1acae130adf647503.svg";
export { ForwardRef as ReactComponent };